export const HFColorCodes = {
  Danger: "#eb3342",
  Gray300: "#dbdbdb",
  Green: "#289548",
  Primary: "#afca0a",
  Primary500: "#63d100",
  Tertiary: "#698796",
  Tertiary100: "#f3faff",
  Warning: "#ffc92b",
  White: "#ffffff",
};
